import React from 'react';
import {Link} from 'react-router-dom';
import _Logo from './_Logo.scss';
import {connect} from 'react-redux'
import CONFIG from 'base/constants/config';

class Logo extends React.Component {

  componentDidUpdate(prevProps, prevState) {
    if(this.props.SystemInfo !== prevProps.SystemInfo) {
      this.forceUpdate();
    }
  }

  render() {
    let {SystemInfo} = this.props
    return (
      <h1 className='logo'>
        <Link to='/' className='logo-link'>
          {SystemInfo && SystemInfo.themeInfo && (<img className='logo-img' alt='logo hội chợ' src={`${CONFIG.VITRADE_IMAGE_URL}/resize/220x220/fairs/download/${SystemInfo.themeInfo.logo ? SystemInfo.themeInfo.logo : ''}`}/>)}
        </Link>
      </h1>
    )
  }
}

const bindStateToProps = (state) => {
  return {
    SystemInfo: state.System.data || {}
  };
};

export default connect(bindStateToProps)(Logo)



// WEBPACK FOOTER //
// ./components/layouts/master/sub-header/Logo.jsx